// @flow

// Organizations
export const ORGA_WRITE = 'organizations:org:write';
